// company component
import { useContext, useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import StateContext from '../stateContext';
import axios from 'axios';
import { Chart as ChartJS } from 'chart.js/auto';
import { Line, Doughnut } from 'react-chartjs-2';

function Company() {

  const { setGlobalHeader, createNotification, userInfo, applicationStati, validUserCreds, setPopup } = useContext(StateContext);
  const { companyName, pageNumber, pPageSize } = useParams();
  var curPathname = window.location.pathname.toLowerCase();
  const [ companyData, setCompanyData ] = useState(
    { 
      'outlook': "Loading company outlook...",
      'listingCount': 0
    }
  );
  const [ chartData, setChartData ] = useState(undefined);
  const [ doughnutChartData, setDoughnutChartData ] = useState(undefined);
  const [listingStats, setListingStats] = useState(undefined);

  // determine if pageNumber and pPageSize are valid
  var offset = 0;
  var pageSize = 0;
  if (parseInt(pPageSize) > 0) {
    pageSize = parseInt(pPageSize);
  } else {
    pageSize = 20;
  }

  if (parseInt(pageNumber) <= 1) {
    offset = 0;
  } else if (parseInt(pageNumber) > 0) {
    offset = (parseInt(pageNumber) - 1) * pageSize;
  }

  useEffect(() => {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/company/get',
    {
      "company_name": companyName,
      "pageSize": pageSize,
      "offset": offset
    }
    ).then((response) => {
      if (response.status == 200 && response.data.success == true && response.data.results > 0) {

        setGlobalHeader(companyName[0].toLocaleUpperCase() + companyName.slice(1) );
        setCompanyData(response.data.result);

        /*
        var chartLables = [];
        var chartData = [];

        const months = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sept.", "Oct.", "Nov.", "Dec."];

        for (var i = 1; i < 14; i++ ) {
          // generate labels
          var date = new Date();
          var curDate = date.getUTCDate() - i
          date.setUTCDate(curDate);
          chartLables.push(`${months[date.getMonth()]} ${date.getUTCDate()}`)
          
          // count listings with matching days
          var listingCount = 0;
          response.data.result.listings.forEach((listing, index) => {
            var listingDate = new Date(listing.date_found * 1000) 

            if (curDate == listingDate.getUTCDate()) {
              listingCount++;
            }
          })

          chartData.push(listingCount);
        }

        setChartData({
          labels: chartLables.toReversed(),
          datasets: [{
            label: 'Job Posting Count',
            data: chartData.toReversed(),
            borderWidth: 1
          }]
        });
        */
        
        setListingStats(
          {
            "openPerc": ((response.data.result.listingStats["total"] - response.data.result.listingStats["closed"] - response.data.result.listingStats["ghost"]) / response.data.result.listingStats["total"]) * 100,
            "closedPerc": (response.data.result.listingStats["total"] - response.data.result.listingStats["open"] - response.data.result.listingStats["ghost"]) / response.data.result.listingStats["total"] * 100,
            "ghostPerc": (response.data.result.listingStats["total"] - response.data.result.listingStats["open"] - response.data.result.listingStats["closed"]) / response.data.result.listingStats["total"] * 100
          }
        )
      } else {
        // prompt error 
        createNotification({
          "status": "error",
          "msg": "Error searching company outlook",
        })
      }
    })
  }, []);

  async function updateApplicationStatus(listingIndex, appID, newApplicationStatus ) {

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;
    
    axios.patch(
        '/api/application/update',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "new_application_status": newApplicationStatus,
        "application_id": appID
      }
      ).then((response) => {
          if (response.status == 200 && response.data.success == true && response.data.results > 0) {
            if (response.data.results <= 0 ) {
              createNotification({
                "status": "error",
                "msg": "Error while updating application status!",
              })
            } else {

              var updatedCompanyData  = {...companyData};
              updatedCompanyData.listings[listingIndex].applicationDetails.result.id = response.data.result.id;
              updatedCompanyData.listings[listingIndex].applicationDetails.result.status = response.data.result.status;
              setCompanyData(updatedCompanyData);

              createNotification({
                "status": "success",
                "msg": "Application status updated!",
              })

            }
          } else {
            // prompt error 
            createNotification({
              "status": "error",
              "msg": "Error while updating application status!",
            })
          }
      })
  }

    async function generateResume(listingIndex) {

    if (!validUserCreds()) {
      // alert user that they need to login
      setPopup({type: "login", "msg": "Become a WorkGuild Premium Member to Generate Resumes!"});
      return;
    }

    // check if user is premium
    if (userInfo.account_type != "premium") {
      setPopup({type: "subscribe", "msg": "Become a WorkGuild Premium Member to Generate Resumes!"});
      return;
    }

    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/resume/create',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "application_id": companyData.listings[listingIndex].applicationDetails["result"]["id"]
      }
      ).then((response) => {

        if (response.status == 200 && response.data.success == true && response.data.results > 0) {
          // update application id's resume status


          var updatedCompanyData  = {...companyData};
          updatedCompanyData.listings[listingIndex].applicationDetails.result.gen_resume_status = response.data.result.status;
          setCompanyData(updatedCompanyData);

          // notify user of success
          createNotification({
            "status": "success",
            "msg": "Resume generation task success!",
          })
          
        } else if (response.data instanceof Object && response.data.result.subscription_needed == true) {
          setPopup({type: "subscribe", "msg": "Join WorkGuild Premium!"});
        } else if (response.data instanceof Object && response.data.result.missing_info && response.data.result.missing_info.length > 0) {
          setPopup({type: "resume_gen_info_missing", msg: "Join WorkGuild Premium!", missingInfo: response.data.result.missing_info});
        } else {
          // prompt error 
          createNotification({
            "status": "error",
            "msg": "Error while generating resume task!",
          })
        }
    })
  }

  async function trackListing(listingIndex) {

    if (!validUserCreds()) {
      // alert user that they need to login
      setPopup({type: "login", "msg": "Login to Track Applications"});
      return;
    }
    
    // set csrf tokens
    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
        '/api/application/create',
      {
        "email": userInfo.email,
        "jwt": userInfo.jwt,
        "listing_id": companyData.listings[listingIndex].id,
      }
      ).then((response) => {
          if (response.status == 200 && response.data.success == true && response.data.results > 0) {

            var updatedCompanyData  = {...companyData};
            updatedCompanyData.listings[listingIndex].applicationDetails = response.data;
            setCompanyData(updatedCompanyData);

            createNotification({
              "status": "success",
              "msg": "Tracking job listing updated!",
            })
          } else {
            // prompt error 
            createNotification({
              "status": "error",
              "msg": "Error tracking listing!",
            })
          }
      })
  }

  // determine max number of pages
  var maxPageCount = parseInt(companyData.listingCount / pageSize);
  if (parseInt(companyData.listingCount / pageSize) - maxPageCount > 0) {
    maxPageCount++;
  }

  // determine current page number
  var cPageNumber = 1;
  if (parseInt(pageNumber) > 1) {
    cPageNumber = parseInt(pageNumber);
  }

  if (parseInt(pageNumber) > maxPageCount) {
    cPageNumber = maxPageCount + 1;
  }

  var pageNavigationLinks = [<Link className="currentPage navPageLinks" key={cPageNumber}>{parseInt(cPageNumber)}</Link>]

  // determine left of page number
  for (var i = cPageNumber; i > cPageNumber - 1 && i > 1; i--) {
    pageNavigationLinks.unshift(<Link className="navPageLinks" to={`/company/${companyName}"}/${i - 1}/${pageSize}`} key={i - 1}>{i - 1}</Link>)
  }

  // determine right of page number
  for (var i = parseInt(cPageNumber) + 1; i < cPageNumber + 2 && i < maxPageCount + 2; i++) {
    if (i * pageSize > 60 && validUserCreds() != true) {
      pageNavigationLinks.push(<button onClick={() => {setPopup({type: "login", "msg": "Login to see more!"});}} style={{backgroundColor: "transparent", fontWeight: "normal"}} key={i}>{i}</button> )
    } else {
      pageNavigationLinks.push(<Link className="navPageLinks" to={`/company/${companyName}/${i}/${pageSize}`} key={i}>{i}</Link>)
    }
  }

  return (
    <main style={{display: "flex", gap: "10px"}}>
      <h3>Company Outlook</h3>
      <p style={{
            margin: "0px", 
            fontSize: "16px",
            maxWidth: "600px",
            margin: "auto",}}>{companyData.outlook}</p>
      { listingStats != undefined ? 
        <section
          style={{
            maxWidth: "600px",
            margin: "auto",
            display: "grid",
            gridTemplateColumns: "30% 30% 30%",
            gridTemplateRows: "auto 100px",
            gridTemplateAreas: `"sumHeader sumHeader sumHeader" "openSum ghostSum closedSum"`,
            justifyContent: "space-evenly",
            gap: "10px"
          }}
        >
          <h3 style={{ gridArea: "sumHeader"}} >Listing Stats</h3>
          <span 
          style={{ 
            gridArea: "openSum",
            backgroundColor: "rgba(11, 219, 49, 0.3)",
            border: "3px solid rgba(11, 219, 49, 0.8)",
            padding: "10px",
            borderRadius: "100%",
            textAlign: "center", 
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }} >
            Open Jobs<br/>{listingStats.openPerc.toFixed(2)} %</span>
          <span style={{ 
            gridArea: "ghostSum",
            backgroundColor: "rgba(79, 9, 210, 0.3)",
            border: "3px solid rgba(79, 9, 210, 0.8)",
            padding: "10px",
            borderRadius: "100%",
            textAlign: "center", 
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }} >Ghost Jobs<br/>{listingStats.ghostPerc.toFixed(2)} %</span>
          <span style={{ 
            gridArea: "closedSum",
            backgroundColor: "rgba(60, 60, 60, 0.3)",
            border: "3px solid rgba(60, 60, 60, 0.8)",
            padding: "10px",
            borderRadius: "100%",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }} >Closed Jobs<br/>{listingStats.closedPerc.toFixed(2)} %</span>
        </section>
        :
        undefined
      }
      <section 
        className='listings' 
        style={{
          margin: "0px", 
          fontSize: "12px", 
          maxWidth: "600px",
          margin: "auto"
        }} 
        >
        { companyData.listings == undefined || companyData.listings.length <= 0 ?
          undefined
          :
          companyData.listings.map((listing, index) => (
            <article key={index} 
              style={{
                padding: "10px",
                border: "solid #e1e1e1 1px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "row",
                gap: "10px"
              }}
            >
              <section 
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 70px",
                  gridTemplateRows: "min-content auto auto",
                  gridTemplateAreas: `
                    "title title"
                    "companyName companyName"
                    "location age"
                  `,
                  width: "70%",
                  maxWidth: "70%",
                  textDecoration: "none",
                  alignItems: "start",
                  gap: "2px"
                }}
              >
                <a href={listing.link} target="_blank" rel="noreferrer" style={{ gridArea: "title", width: "100%", fontSize: "14px", fontWeight: "bold"}}>{listing.job_title}</a>
                <a href={ curPathname?.startsWith("/company") ? undefined : `/company/${companyName}`} style={{ fontWeight: "normal", gridArea: "companyName", width: "100%", fontSize: "12px", display: "flex", flexDirection: "row", gap: "5px", alignItems: "center"}}>
                  <span>{listing.company_name_full}</span>
                  <svg width="10px" height="10px" viewBox="0 0 24 24" style={{color: "blue"}}fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
                <h5 style={{ fontWeight: "normal", gridArea: "location", width: "100%", display: 'flex', gap: "5px", alignItems: "center", color: "#87898b", alignSelf: "end"}}>
                  <svg style={{minWidth: "15px", maxWidth: "15px"}} width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>{listing.location}</span>
                </h5>
                <h5 style={{gridArea: "age", color: "#87898b", width: "100%", textAlign: "right", position: "relative", alignSelf: "end"}}>{listing.age.lessThan == true ? "~" : undefined}{`${listing.age.time} ${listing.age.unit}`}{listing.age.time > 1 ? "s" : undefined }</h5>
              </section>
              <section
                style={{
                  width: "30%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px"
                }}
              >
              { listing?.applicationDetails?.success == true && listing?.applicationDetails?.results > 0 ?
                <>
                  <select className="submit-light" onChange={(e) => {updateApplicationStatus(index, listing.applicationDetails.result.id, e.target.selectedOptions[0].value)}} value={listing.applicationDetails.result.status}
                    style={{
                      padding: "5px",
                      border: "none",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      textAlign: "center",
                      fontSize: "12px"
                    }}
                  >
                    {applicationStati.map((stati, index) => (
                      <option key={index} value={stati}>{stati.charAt(0).toUpperCase() + stati.slice(1)}</option>
                    ))}
                  </select>
                  {listing.validated == 1 && listing.applicationDetails.result.gen_resume_status == "ready" ? <Link className="next-light" style={{ fontSize: "12px", textAlign: "center", borderRadius: "5px", padding: "5px", fontWeight: "bold"}} to={"/resume/" + listing.applicationDetails.result.id}>View Resume</Link> : "" }
                  {listing.validated == 1 && listing.applicationDetails.result.gen_resume_status == "pending" ? <button className='warning-light' style={{fontWeight: "bold"}} >Resume Pending</button> : ""} 
                  {listing.validated == 1 && listing.applicationDetails.result.gen_resume_status == undefined ? <button className='subscribe' style={{ fontSize: "12px", fontWeight: "bold"}} onClick={() => {generateResume(index)}}>Generate Resume</button> : ""} 
                </>  
                :
                <>
                  <button className="next" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: "12px"}} onClick={() => {trackListing(index)}}>
                    Track
                    <svg width="15px" height="15px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 7.8C5 6.11984 5 5.27976 5.32698 4.63803C5.6146 4.07354 6.07354 3.6146 6.63803 3.32698C7.27976 3 8.11984 3 9.8 3H14.2C15.8802 3 16.7202 3 17.362 3.32698C17.9265 3.6146 18.3854 4.07354 18.673 4.63803C19 5.27976 19 6.11984 19 7.8V21L12 17L5 21V7.8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </>
              }
              {
                validUserCreds() != true ? 
                <button className="subscribe" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: "12px"}} onClick={() => {generateResume(index)}}>
                  Generate Resume
                </button>
                : undefined
              }
              </section>
            </article>
          ))}
          { companyData.listings == undefined || companyData.listings.length <= 0 ?
            undefined
            :
            <nav className='pageControls'>
              {cPageNumber > 1 && companyData.listingCount > pageSize ? <Link className="navPageLinks" to={`/company/${companyName}/${cPageNumber - 1}/${pageSize}`}>{"<"}</Link> : undefined}
              {pageNavigationLinks}
              
              {cPageNumber <= maxPageCount ? 
                <>
                {(cPageNumber + 1) * pageSize >= 60  && validUserCreds() != true ? 
                  <button onClick={() => {setPopup({type: "login", "msg": "Login to see more!"});}} style={{backgroundColor: "transparent", fontWeight: "normal"}}> {">"}</button> 
                  : 
                  <Link className="navPageLinks" to={`/company/${companyName}/${cPageNumber + 1}/${pageSize}`}>{">"}</Link> 
                }
                </>
                : undefined}
            </nav>
          }
      </section>
    </main>
  )
}

export default Company;